import type {StandardSchemaV1} from '@standard-schema/spec';

type WithNonsensitiveMetadata<T> = T &
  Partial<{
    __stripeMetadata: {
      nonsensitive: true;
    };
  }>;

// adds the nonsensitive metadata to the schema for runtime use
export const addNonsensitiveMetadataToSchema = <
  TSchema extends StandardSchemaV1,
>(
  schema: TSchema,
): StandardSchemaV1<
  StandardSchemaV1.InferInput<TSchema>,
  StandardSchemaV1.InferOutput<TSchema>
> => {
  (schema as WithNonsensitiveMetadata<TSchema>).__stripeMetadata = {
    nonsensitive: true,
  };

  return schema as StandardSchemaV1<
    StandardSchemaV1.InferInput<TSchema>,
    StandardSchemaV1.InferOutput<TSchema>
  >;
};

export const isNonsensitiveSchema = <TSchema extends StandardSchemaV1>(
  schema: TSchema,
): true | undefined => {
  return (schema as WithNonsensitiveMetadata<TSchema>).__stripeMetadata
    ?.nonsensitive;
};
